/**
 * Coordinates independent asynchronous startup steps and emits readiness once.
 *
 * @param {string[]} requiredSteps
 */
export function createReadinessGate(requiredSteps) {
  const required = new Set(requiredSteps);
  const completed = new Set();
  const listeners = new Set();
  let ready = required.size === 0;

  function notifyIfReady() {
    if (ready || completed.size !== required.size) return;

    ready = [...required].every((step) => completed.has(step));
    if (!ready) return;

    listeners.forEach((listener) => listener());
    listeners.clear();
  }

  function markReady(step) {
    if (!required.has(step)) {
      throw new Error(`Unknown readiness step: ${step}`);
    }

    completed.add(step);
    notifyIfReady();
  }

  function onReady(listener) {
    if (ready) {
      listener();
      return () => {};
    }

    listeners.add(listener);
    return () => listeners.delete(listener);
  }

  return {
    isReady: () => ready,
    markReady,
    onReady,
  };
}
